const state = () => {
  const suitability = {
    selectedTeam: {
      name: null,
      rating: null,
    },
    coreStyle: {
      attacking: null,
      defensive: null,
      balanced: null,
    },
    attackingStyle: {
      direct: null,
      short: null,
      mixed: null,
    },
    defensiveStyle: {
      aggressive: null,
      cautious: null,
      mixed: null,
    },
    crossing: {
      floated: null,
      whipped: null,
      low: null,
      mixed: null,
    },
    inTransition: {
      counterPress: null,
      regroup: null,
      counter: null,
      holdShape: null,
      distributeQuickly: null,
      rollItOut: null,
      throwItLong: null,
      takeShortKicks: null,
      takeLongKicks: null,
    },
    inPossession: {
      attackingWidth: null,
      passIntoSpace: null,
      playOutOfDefence: null,
      higherTempo: null,
      workBallIntoBox: null,
      hitEarlyCrosses: null,
      shootOnSight: null,
      runAtDefence: null,
      beMoreExpressive: null,
    },
    outOfPossession: {
      useOffsideTrap: null,
      lineOfEngagement: null,
      defensiveLine: null,
      defensiveWidth: null,
      tighterMarking: null,
      getStuckIn: null,
    },
  }

  return suitability;
};


const mutations = {
  setSelectedTeam (state, value) {
    state.selectedTeam.name = value.name;
    state.selectedTeam.rating = value.rating;
  },

  setSuitability (state, value) {
    for (const [key, object] of Object.entries(value)) {
      state[key] = {
        ...state[key],
        ...object,
      };
    }
  },
};


const getters = {};


export default {
  state,
  mutations,
  getters
};
